// "unknown-outcome": the confirm request got no answer, so the backend may
// have charged. The session is kept and the retry is idempotent against it.
// "charged-pending-review": the gateway charged but storing the donation
// failed; nothing the donor does can finish it, so there is no retry.
// "session-expired": the backend refused an expired session without charging.
export type SubmissionError =
  | "failed"
  | "session-expired"
  | "unknown-outcome"
  | "charged-pending-review";

export const SUBMISSION_ERROR_COPY_KEY: Record<SubmissionError, string> = {
  failed: "submission-error",
  "session-expired": "submission-session-expired",
  "unknown-outcome": "submission-outcome-unknown",
  "charged-pending-review": "submission-charged-pending-review",
};
